import { apiClient } from './client'

export type ExportOptions = {
  can_export: boolean
  can_edit_settings: boolean
  formats: { id: string; capable: boolean; reason: string }[]
  change_types: string[]
  pdf_parts: string[]
  preference: {
    period_kind: string
    period_n: number
    change_types: string[]
    name_mode: string
    pdf_parts: string[]
    week_start?: string | null
    date_from?: string | null
    date_to?: string | null
  } | null
  horizon_days: number
  school_mail_ready: boolean
  mail_addresses: string[]
  link_mode: string
  link_ttl: string
  teacher_mail_mode: string
  can_mail: boolean
  addressed_warning: string
  settings: SchoolExportSettings | null
}

export type SchoolExportSettings = {
  export_roles: string[]
  settings_roles: string[]
  mail_addresses: string[]
  mail_interval: string
  mail_weekday: number
  mail_monthday: number
  mail_time: string
  link_mode: string
  link_ttl: string
  horizon_days: number
  teacher_mail_mode: string
  period_kind: string
  period_n: number
  change_types: string[]
  name_mode: string
  pdf_parts: string[]
  week_start?: string | null
  date_from?: string | null
  date_to?: string | null
  addressed_warning_ack: boolean
  schedule_paused: boolean
}

export type ExportRequest = {
  period_kind: string
  period_n?: number
  horizon_days?: number
  change_types: string[]
  name_mode: string
  pdf_parts: string[]
  week_start?: string
  date_from?: string
  date_to?: string
  to?: string
  school_mail?: boolean
  formats?: string[]
  subject_teacher_id?: string
}

export const timetableExportApi = {
  options: () => apiClient.get<ExportOptions>('/api/v1/timetable-export/options').then(r => r.data),
  savePreferences: (body: ExportRequest) => apiClient.put('/api/v1/timetable-export/preferences', body).then(r => r.data),
  saveSettings: (body: SchoolExportSettings) => apiClient.put('/api/v1/timetable-export/settings', body).then(r => r.data),
  download: (body: ExportRequest) =>
    apiClient.post('/api/v1/timetable-export/download', body, { responseType: 'blob', timeout: 120000 }),
  mail: (body: ExportRequest) => apiClient.post('/api/v1/timetable-export/mail', body).then(r => r.data),
}

export function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
